export function LoadingScreen({ text = 'กำลังโหลด...' }: { text?: string }) {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-white">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-line border-t-transparent" />
      <p className="text-sm text-gray-500">{text}</p>
    </div>
  );
}
